.section {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1_5);
  margin-bottom: var(--tuna-spacing-5);
}

.headingRow {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: var(--tuna-spacing-0_5) var(--tuna-spacing-1_5);
}

.heading {
  margin: 0;
  font-size: var(--tuna-typography-fontSize-2xl);
}

.caption {
  color: var(--tuna-content-secondary);
}

.empty {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-2);
  padding: var(--tuna-spacing-3);
  border: 1px dashed var(--tuna-border-default);
  border-radius: var(--tuna-shape-radius-xl);
}

.emptyTitle {
  margin: 0;
  font-size: var(--tuna-typography-fontSize-lg);
  font-weight: var(--tuna-typography-fontWeight-bold);
}

.emptyBody {
  margin: var(--tuna-spacing-0_5) 0 0;
  color: var(--tuna-content-secondary);
}

.hint {
  margin: 0;
  color: var(--tuna-content-secondary);
}

.error {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--tuna-spacing-1) var(--tuna-spacing-2);
}
